module.exports = __webpack_public_path__ + "static/media/popcorn-money-2.907e8d1e.png";